
export default {
    props: {
        floatedClass: {
            type: String,
            default: '',
        },
        borderColor: {
            type: String,
            default: '',
        },
        src: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: () => {
                return []
            },
        },
        orderClass: {
            type: String,
            default: '',
        },
        articleSlugs: {
            type: Array,
            default: () => {
                return []
            },
        },
        noteContent: {
            type: Array,
            default: () => {
                return []
            },
        },
        text: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: '',
        },
        noPic: Boolean,
    },

    methods: {
        getOrderClass(idx) {
            return `${this.orderClass} num-${idx + 1}`
        },
    },
}
